import useManagement, { selectors } from 'client/hooks/useManagement'
import { EntityProps } from 'client/types'
import CommonSurvey from 'common/components/entities/SurveyNew'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import React from 'react'
import BaseEntityNew from '../../core/BaseEntity/BaseEntityNew'
import ChildrenEntities from '../../core/ChildrenEntities'

function Survey({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<SurveyInterface>) {
  const isSurveyResult = useManagement(selectors.isSurveyResult)

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonSurvey
        attrId={entity.htmlAttrId}
        question={entity.questions[0]}
        questionTitleFontSize={entity.questionTitleFontSize}
        mobileQuestionTitleFontSize={entity.mobileQuestionTitleFontSize}
        questionSubTitleFontSize={entity.questionSubTitleFontSize}
        mobileQuestionSubTitleFontSize={entity.mobileQuestionSubTitleFontSize}
        fontFamily={entity.fontFamily}
        mobileFontFamily={entity.mobileFontFamily}
        fontStyle={entity.fontStyle}
        mobileFontStyle={entity.mobileFontStyle}
        fontWeight={entity.fontWeight}
        mobileFontWeight={entity.mobileFontWeight}
        answerFontSize={entity.answerFontSize}
        mobileAnswerFontSize={entity.mobileAnswerFontSize}
        answerColor={entity.answerColor}
        answerOutlineColor={entity.answerOutlineColor}
        answerBackgroundColor={entity.answerBackgroundColor}
        questionTitleColor={entity.questionTitleColor}
        questionSubTitleColor={entity.questionSubTitleColor}
        answerBorder={entity.answerBorder}
        mobileAnswerBorder={entity.mobileAnswerBorder}
        backgroundColor={entity.backgroundColor}
        mobileBackgroundColor={entity.mobileBackgroundColor}
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        showResult={isSurveyResult}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        choose={() => {}}
        isEdit
      >
        <ChildrenEntities
          id={entity.id}
          type={entity.type}
          childIds={entity.childIds}
          isReadOnly={entity.isReadOnly}
        />
      </CommonSurvey>
    </BaseEntityNew>
  )
}

export function getSurveyFontProperties(entity: SurveyInterface) {
  const fontProperties = entity.fontFamily
    ? [
        {
          fontFamily: entity.fontFamily,
          fontStyle: entity.fontStyle,
          fontWeight: entity.fontWeight,
        },
      ]
    : []

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }

  return fontProperties
}

export function getSurveyCustomFontProperties(entity: SurveyInterface) {
  const fontProperties =
    entity.fontFamily && entity.fontFileId
      ? [
          {
            fontFamily: entity.fontFamily,
            fontFileId: entity.fontFileId,
          },
        ]
      : []

  if (entity.mobileFontFamily && entity.mobileFontFileId) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontFileId: entity.mobileFontFileId,
    })
  }

  return fontProperties
}
export default Survey
